import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--color-gray50);

  & > * + * {
    margin-left: 12px;
  }

  .one-pane & {
    margin-top: -16px;
    margin-left: -12px;
    padding-left: 24px;
    margin-bottom: 16px;
  }
`;

interface Props {
  children: React.ReactNode;
}

export const PageHeading = ({ children }: Props) => {
  return <Wrapper className="page-heading">{children}</Wrapper>;
};
